import { render } from "./VAccordion.vue?vue&type=template&id=b70f4d4a"
import script from "./VAccordion.vue?vue&type=script&lang=js"
export * from "./VAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__